/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetSafetyPlanResponse } from '../models/get-safety-plan-response';
import { GetFormRequest } from '../models/get-form-request';
import { CreateSafetyPlanRequest } from '../models/create-safety-plan-request';
@Injectable({
  providedIn: 'root',
})
class SafetyPlanService extends __BaseService {
  static readonly SafetyPlanGetAllPath = '/SafetyPlan/GetAll';
  static readonly SafetyPlanGetByIdPath = '/SafetyPlan/GetById';
  static readonly SafetyPlanCreatePath = '/SafetyPlan/Create';
  static readonly SafetyPlanUploadFilePath = '/SafetyPlan/UploadFile';
  static readonly SafetyPlanDeletePath = '/SafetyPlan/Delete';
  static readonly SafetyPlanDeleteRangePath = '/SafetyPlan/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  SafetyPlanGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetSafetyPlanResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/SafetyPlan/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetSafetyPlanResponse>>;
      })
    );
  }  SafetyPlanGetAll(): __Observable<Array<GetSafetyPlanResponse>> {
    return this.SafetyPlanGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetSafetyPlanResponse>)
    );
  }

  /**
   * @param request undefined
   */
  SafetyPlanGetByIdResponse(request: GetFormRequest): __Observable<__StrictHttpResponse<GetSafetyPlanResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyPlan/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetSafetyPlanResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyPlanGetById(request: GetFormRequest): __Observable<GetSafetyPlanResponse> {
    return this.SafetyPlanGetByIdResponse(request).pipe(
      __map(_r => _r.body as GetSafetyPlanResponse)
    );
  }

  /**
   * @param request undefined
   */
  SafetyPlanCreateResponse(request: CreateSafetyPlanRequest): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyPlan/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyPlanCreate(request: CreateSafetyPlanRequest): __Observable<string> {
    return this.SafetyPlanCreateResponse(request).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param params The `SafetyPlanService.SafetyPlanUploadFileParams` containing the following parameters:
   *
   * - `FormId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  SafetyPlanUploadFileResponse(params: SafetyPlanService.SafetyPlanUploadFileParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.FormId != null) { __formData.append('FormId', params.FormId as string | Blob);}
    if (params.File != null) { __formData.append('File', params.File as string | Blob);}
    if (params.DirectoryPath != null) { __formData.append('DirectoryPath', params.DirectoryPath as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyPlan/UploadFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SafetyPlanService.SafetyPlanUploadFileParams` containing the following parameters:
   *
   * - `FormId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  SafetyPlanUploadFile(params: SafetyPlanService.SafetyPlanUploadFileParams): __Observable<Blob> {
    return this.SafetyPlanUploadFileResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  SafetyPlanDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyPlan/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  SafetyPlanDelete(id?: string): __Observable<Blob> {
    return this.SafetyPlanDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  SafetyPlanDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyPlan/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  SafetyPlanDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.SafetyPlanDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module SafetyPlanService {

  /**
   * Parameters for SafetyPlanUploadFile
   */
  export interface SafetyPlanUploadFileParams {
    FormId?: string;
    File?: null | Blob;
    DirectoryPath?: null | string;
  }
}

export { SafetyPlanService }
